import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminPanelUserPreviewStateService } from '../state/admin-panel-user-preview-state.service';
import {APP_PATHS} from '../../../../core/config/app-paths';

export const AdminUserPreviewStateGuard: CanActivateFn = () => {
  const router = inject(Router);
  const state = inject(AdminPanelUserPreviewStateService);

  if (state.selectedUser()) {
    return true;
  }

  return router.createUrlTree([
    `/${APP_PATHS.admin.root}/${APP_PATHS.admin.users}`,
  ]);
};
